var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30872",
    "data-name": "Path 30872",
    d: "M0,0H48V48H0Z",
    fill: "#c7cdd1",
    opacity: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Temporarily_lock_card",
    "data-name": "Temporarily lock card",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27780",
    "data-name": "Group 27780",
    transform: "translate(13.714 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27778",
    "data-name": "Group 27778"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30870",
    "data-name": "Path 30870",
    d: "M1272.237,236.093h0v-9.471a2.142,2.142,0,0,0-2.12-2.164h-17.261a2.142,2.142,0,0,0-2.12,2.164v9.471h0c0,.031-.006.061-.006.092,0,5.019,4.814,9.087,10.752,9.087s10.752-4.068,10.752-9.087C1272.242,236.154,1272.237,236.124,1272.237,236.093Z",
    transform: "translate(-1250.738 -211.43)",
    fill: "#3d72fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27777",
    "data-name": "Group 27777",
    transform: "translate(3.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30871",
    "data-name": "Path 30871",
    d: "M1262.848,206.468a7.768,7.768,0,0,0-7.47,7.849c0,1.436.014,2.575.028,3.672h2.827c-.014-1.089-.028-2.229-.028-3.672a4.657,4.657,0,1,1,9.293,0l-.007,3.672h2.827l.007-3.672A7.769,7.769,0,0,0,1262.848,206.468Z",
    transform: "translate(-1255.378 -206.468)",
    fill: "#ffb063"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27779",
    "data-name": "Group 27779",
    transform: "translate(8.118 17.884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_182",
    "data-name": "Union 182",
    d: "M1.106,7.157V4.879A2.7,2.7,0,0,1,0,2.688,2.661,2.661,0,0,1,2.633,0,2.661,2.661,0,0,1,5.267,2.688a2.7,2.7,0,0,1-1.106,2.19V7.157a1.527,1.527,0,1,1-3.055,0Z",
    transform: "translate(0)",
    fill: "#121b45",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.a9cd3a708362fc844180d89dbb3e766a.svg";
export { ForwardRef as ReactComponent };